<ng-container *ngIf="loaded; else loadingContent">
    <app-dev-toolbar *ngIf="!production && hostName === 'localhost'"></app-dev-toolbar>

    <div class="top-bar">
        <div class="container-md mx-auto w-100 px-md-3">
            <div class="row small-gutter top-bar-row">
                <div class="col-auto">
                    <div class="d-flex align-items-center h-100">
                        <p class="paragraph-2 m-0 mr-2 d-none d-lg-block" style="width: 57px">{{ currentTime }}</p>
                        <div class="international-ranking">
                            <button
                                nbButton
                                ghost
                                [routerLink]="['ranking/international']"
                                nbTooltip="{{ 'RANKING.INTERNATIONAL-RANKING' | translate }}"
                            >
                                <nb-icon icon="globe-2-outline"></nb-icon>
                            </button>
                        </div>
                        <ul class="socials">
                            <li *ngFor="let social of registers">
                                <a [href]="social.item.routerLink" target="_blank" rel="noopener noreferrer">
                                    <fa-icon
                                        [icon]="icons[social.item.iconeLink]"
                                        *ngIf="icons[social.item.iconeLink]"
                                    ></fa-icon>
                                </a>
                            </li>
                        </ul>
                        <div class="language" ngbDropdown #lngDropdown="ngbDropdown">
                            <button class="btn-clean toggle" (click)="lngDropdown.open()" type="button">
                                <!-- prettier-ignore -->

                                <img class="rounded-circle" width="18" [src]="'/assets/flags/1x1/' + (languageService.selectedLanguage | async)?.split('-')?.[1]?.toLowerCase() + '.svg'">

                                <!-- prettier-ignore -->
                                <span class="d-inline-block align-middle mx-2 text-uppercase" *ngIf="languageService.selectedLanguage | async">{{ (languageService.selectedLanguage | async).split('-')?.[0] }}</span>

                                <fa-icon [icon]="icons.angleDown" class="align-middle"></fa-icon>
                            </button>
                            <div ngbDropdownMenu>
                                <!-- prettier-ignore -->
                                <a
                                class="cursor-pointer"
                                ngbDropdownItem
                                *ngFor="let availableLang of (languageService.availableLangs | async)"
                                (click)="changeLang(availableLang)"
                            >
                               <!-- prettier-ignore -->
                               <img class="rounded-circle" width="18" [src]="'/assets/flags/1x1/' + availableLang?.split('-')?.[1]?.toLowerCase() + '.svg'">
                               <!-- prettier-ignore -->
                               <span class="d-inline-block align-middle mx-2 text-uppercase">{{ availableLang.split('-')?.[0] }}</span>
                            </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-auto ml-auto">
                    <div class="d-flex align-items-center h-100">
                        <div class="auth">
                            <div
                                class="user"
                                ngbDropdown
                                #dropdown="ngbDropdown"
                                *ngIf="userService.currentUser | async; else loginBlock"
                            >
                                <div class="avatar">
                                    <!-- prettier-ignore -->
                                    <img
                                [src]="(userService.currentUser | async).url_avatar"
                                [alt]="(userService.currentUser | async).nome_abreviado" />
                                </div>
                                <button class="btn-clean toggle" (click)="dropdown.open()" type="button">
                                    <!-- prettier-ignore -->
                                    <span class="d-inline-block align-middle mx-2">{{ (userService.currentUser | async).nome_abreviado}}</span>
                                    <fa-icon [icon]="icons.angleDown" class="align-middle"></fa-icon>
                                </button>
                                <div ngbDropdownMenu>
                                    <a class="cursor-pointer" ngbDropdownItem [routerLink]="['/user/games']">
                                        <span>{{ "HEADER.PROFILE.MY-GAMES" | translate }}</span>
                                        <fa-icon [icon]="icons.games"></fa-icon>
                                    </a>
                                    <a class="cursor-pointer" ngbDropdownItem [routerLink]="['/user/profile']">
                                        <span>{{ "HEADER.PROFILE.MY-DATA" | translate }}</span>
                                        <fa-icon [icon]="icons.user"></fa-icon>
                                    </a>
                                    <a class="cursor-pointer" ngbDropdownItem [routerLink]="['/user/my-documents']">
                                        <span>{{ "HEADER.PROFILE.MY-DOCUMENTS" | translate }}</span>
                                        <fa-icon [icon]="icons.documents"></fa-icon>
                                    </a>
                                    <a
                                        class="cursor-pointer"
                                        ngbDropdownItem
                                        [routerLink]="['/user/affiliations-type']"
                                    >
                                        <span>{{ "HEADER.PROFILE.FILIATIONS" | translate }}</span>
                                        <fa-icon [icon]="icons.userFiliation"></fa-icon>
                                    </a>
                                    <a class="cursor-pointer" ngbDropdownItem [routerLink]="['/user/finances']">
                                        <span>{{ "HEADER.PROFILE.FINANCES" | translate }}</span>
                                        <fa-icon [icon]="icons.userFinances"></fa-icon>
                                    </a>
                                    <a class="cursor-pointer" ngbDropdownItem [routerLink]="['/user/certificates']">
                                        <span>{{ "HEADER.PROFILE.CERTIFICATES" | translate }}</span>
                                        <fa-icon [icon]="icons.userCertificates"></fa-icon>
                                    </a>
                                    <a class="cursor-pointer" ngbDropdownItem [routerLink]="['/user/cards']">
                                        <span>{{ "HEADER.PROFILE.CARDS" | translate }}</span>
                                        <fa-icon [icon]="icons.card"></fa-icon>
                                    </a>
                                    <a class="cursor-pointer" ngbDropdownItem [routerLink]="['/auth/change-password']">
                                        <span>{{ "HEADER.PROFILE.CHANGE-PASSWORD" | translate }}</span>
                                        <fa-icon [icon]="icons.lock"></fa-icon>
                                    </a>
                                    <a
                                        class="cursor-pointer"
                                        *ngIf="wtnLink != null"
                                        ngbDropdownItem
                                        href="{{ wtnLink }}"
                                    >
                                        <img
                                            height="20px"
                                            class="mr-1"
                                            src="/assets/images/wtn-symbol.png"
                                            alt="wtn-logo"
                                        />
                                        <span>{{ "WTN.CTA.REGISTER" | translate }}</span>
                                        <fa-icon [icon]="icons.chevronRight"></fa-icon>
                                    </a>
                                    <a class="cursor-pointer" ngbDropdownItem (click)="logout()">
                                        <span>{{ "HEADER.PROFILE.LOGOUT" | translate }}</span>
                                        <fa-icon [icon]="icons.angleRight"></fa-icon>
                                    </a>
                                </div>
                            </div>
                            <ng-template #loginBlock>
                                <a [routerLink]="['/auth/login']" class="mr-3"
                                    ><fa-icon [icon]="icons.user" size="lg"></fa-icon>
                                    {{ "HEADER.LOGIN" | translate }}</a
                                >
                                <a [routerLink]="['/auth/register']" class="d-none d-sm-block"
                                    ><fa-icon [icon]="icons.userPlus" size="lg"></fa-icon>
                                    {{ "MENU.REGISTER" | translate }}</a
                                >
                            </ng-template>
                        </div>
                        <div class="separator"></div>
                        <div class="search-toggler">
                            <button nbButton size="small" ghost class="btn-clean" (click)="openSearch()">
                                <nb-icon icon="search"></nb-icon>
                            </button>
                        </div>
                    </div>
                </div>
                <!-- <div class="col-6 col-md-auto d-none d-md-block ml-auto">
                <div class="search">
                    <form>
                        <input type="text" name="text" />
                        <button>
                            <fa-icon [icon]="icons.search"></fa-icon>
                        </button>
                    </form>
                </div>
            </div> -->
            </div>
        </div>
    </div>

    <div
        class="search-container"
        [ngClass]="{
            'search-container-open': searchOpen,
            'search-container-hasResults': searchResults && searchResults.length
        }"
    >
        <button class="search-close btn-clean">
            <fa-icon [icon]="icons.close" (click)="closeSearch()"></fa-icon>
        </button>
        <div class="search-box">
            <form method="POST" (ngSubmit)="search($event, searchInput.value)">
                <input type="text" name="text" placeholder="{{ 'HEADER.SEARCH.FOR' | translate }}" #searchInput />
                <button class="btn-clean">
                    <fa-icon [icon]="icons.search"></fa-icon>
                </button>
            </form>
        </div>
        <div class="search-results">
            <div *ngFor="let result of searchResults" class="search-results-col">
                <h2 class="result-label">{{ result.label }}</h2>
                <ng-container *ngFor="let resultItem of result.result">
                    <div [class]="['result-item', 'result-item-' + result.type.toString().toLowerCase()]">
                        <ng-container [ngSwitch]="result.type">
                            <!-- Noticias -->
                            <ng-container *ngSwitchCase="'1'">
                                <a
                                    class="result-item-link"
                                    [routerLink]="['/news', resultItem.url_amigavel]"
                                    (click)="closeSearch()"
                                >
                                    <div class="result-item-icon">
                                        <fa-icon [icon]="icons.news"></fa-icon>
                                    </div>
                                    <div>
                                        <span class="result-item-title d-block">{{ resultItem.title }}</span>
                                        <span class="result-item-meta d-block">{{ resultItem.dt_post }}</span>
                                    </div>
                                    <div class="result-item-image" *ngIf="resultItem.images?.length">
                                        <img [src]="resultItem.images[0].mini" [alt]="resultItem.title" />
                                    </div>
                                </a>
                            </ng-container>

                            <!-- Manchetes -->
                            <ng-container *ngSwitchCase="'2'">
                                <a
                                    class="result-item-link"
                                    [routerLink]="['/news', resultItem.url_amigavel]"
                                    (click)="closeSearch()"
                                >
                                    <div class="result-item-icon">
                                        <fa-icon [icon]="icons.star"></fa-icon>
                                    </div>
                                    <div>
                                        <span class="result-item-title d-block">{{ resultItem.title }}</span>
                                        <span class="result-item-meta d-block">{{ resultItem.dt_post }}</span>
                                    </div>
                                    <div class="result-item-image" *ngIf="resultItem.images?.length">
                                        <img [src]="resultItem.images[0].mini" [alt]="resultItem.title" />
                                    </div>
                                </a>
                            </ng-container>

                            <!-- Videos -->
                            <ng-container *ngSwitchCase="'3'">
                                <a
                                    class="result-item-link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    [href]="resultItem.videos[0].url_video"
                                    (click)="closeSearch()"
                                >
                                    <div class="result-item-icon">
                                        <fa-icon [icon]="icons.youtube"></fa-icon>
                                    </div>
                                    <span class="result-item-title">{{ resultItem.title }}</span>
                                    <div class="result-item-image">
                                        <img [src]="resultItem.videos[0].url_capa" [alt]="resultItem.title" />
                                    </div>
                                </a>
                            </ng-container>

                            <!-- Torneios -->
                            <ng-container *ngSwitchCase="'4'">
                                <!-- prettier-ignore -->
                                <a class="tournament"
                                [routerLink]="['/' + resultItem.redirect.route + '/' + resultItem.redirect.component + '/' + resultItem.redirect.tournamentId]"
                                (click)="closeSearch()">
                                <div class="tournament-img">
                                    <img
                                        [src]="resultItem.url_avatar"
                                        [alt]="resultItem.por"
                                    />
                                </div>
                                <div class="tournament-content">
                                    <p class="tournament-title">
                                        {{ resultItem.nome_torneio }}
                                    </p>
                                    <div class="tournament-info">
                                        <div class="mr-3">
                                            <span>{{
                                                "GENERAL.PERIOD" | translate
                                            }}</span>
                                            <p>
                                                {{ resultItem.dt_inicio }}
                                                até
                                                {{ resultItem.dt_final }}
                                            </p>
                                        </div>
                                        <div>
                                            <span>{{
                                                "GENERAL.LOCAL" | translate
                                            }}</span>
                                            <p>
                                                {{ resultItem.cidade }} /
                                                {{ resultItem.uf }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </a>
                            </ng-container>

                            <!-- Regulamentos -->
                            <ng-container *ngSwitchCase="'5'">
                                <article
                                    [ngClass]="{
                                        'attached-card': true,
                                        'attached-card-pdf': resultItem.content_type === 1,
                                        'attached-card-text':
                                            resultItem.content_type === 2 || resultItem.content_type === 3,
                                        'attached-card-text-big': resultItem.content_type === 2
                                    }"
                                >
                                    <a [href]="resultItem.link_document" target="_blank" rel="noreferrer noopener">
                                        <h3 class="attached-card-title">
                                            {{ resultItem.description }}
                                        </h3>
                                        <div class="attached-card-footer">
                                            <span>{{ resultItem.dt_document }}</span>
                                            <img
                                                src="/assets/images/pdf.png"
                                                alt="Baixar PDF"
                                                width="24px"
                                                *ngIf="resultItem.content_type === 1"
                                            />
                                        </div>
                                        <!-- <div class="attached-card-pdf-hover">
                                    <span>Ver PDF</span>
                                    <img
                                        src="/assets/images/pdf.png"
                                        alt="Ver PDF"
                                        width="42"
                                        *ngIf="attached.content_type === 1"
                                    />
                                </div> -->
                                    </a>
                                </article>
                            </ng-container>
                        </ng-container>
                    </div>
                </ng-container>
                <button
                    class="search-results-btn"
                    *ngIf="result.showAll && result.route"
                    [routerLink]="['/' + result.route]"
                    (click)="closeSearch()"
                >
                    {{ "GENERAL.SEE-ALL" | translate }}
                </button>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #loadingContent>
    <ngx-skeleton height="42px" margin="4px 16px 4px 16px"></ngx-skeleton>
</ng-template>
